import {
    ConfigurableCartItem,
    GiftCardCartItem,
    SimpleCartItem,
    CartItemInterface,
    Maybe
} from '@pylot-data/pylotschema'

type CartItem =
    | Array<ConfigurableCartItem | SimpleCartItem | GiftCardCartItem>
    | []

export const getCartItemSplited = (
    items: Maybe<CartItemInterface>[],
    skus: Array<string> | undefined
) => {
    const freeCartItem = [] as
        | Array<ConfigurableCartItem | SimpleCartItem | GiftCardCartItem>
        | []
    const paidCartItem = [] as
        | Array<ConfigurableCartItem | SimpleCartItem | GiftCardCartItem>
        | []
    items.forEach((item) => {
        if (skus?.includes(item?.product.sku as never)) {
            return freeCartItem.push(item as never)
        }
        return paidCartItem.push(item as never)
    })
    return {
        freeCartItem,
        paidCartItem
    }
}
